var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('appeals-table',{attrs:{"items":_vm.items,"total":_vm.total,"is-fetch":_vm.isFetch},on:{"update:options":_vm.onTableOptionsUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }